import React from "react";

export const Home = () => {
  return (
    <label style={{ fontFamily: "Arial" }}>
      You changed the url didn't you 😏
    </label>
  );
};
